<template>
  <div class="app-container">
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClicktab" style="padding-left: 5px;">
        <el-tab-pane label="卷板库存" name="first" :lazy="true">
          <div>
            <div class="formBox margbot" ref="searchBoxJB">
              <el-form :inline="true" :model="formDataJB" label-width="90px" size="mini">
                <div class="formItemBox">
                <el-form-item label="仓库名称:">
                  <el-select filterable clearable placeholder="请选择仓库名称" v-model="CKName" multiple>
                    <el-option v-for="(item, index) in CKData" :key="index" :label="item.relTenantName" :value="item.relTenantCode">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="捆包编号:">
                  <el-input v-model="gangJuanNum" placeholder="可支持多个" type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="入库时间:">
                  <div style="display: flex;">
                    <el-date-picker v-model="formDataJB.instockDateStart" type="datetime" placeholder="请选择入库日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    -
                    <el-date-picker v-model="formDataJB.instockDateEnd" placeholder="请选择入库日期" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                  </div>
                </el-form-item>
                <el-form-item label="品牌:">
                  <el-input v-model="formDataJB.steelMillName" placeholder="请输入品牌"></el-input>
                </el-form-item>
                <el-form-item label="车船编号:">
                  <el-input v-model="formDataJB.vehicleNumber" placeholder="请输入车船号"></el-input>
                </el-form-item>
                <el-form-item label="材质:">
                  <el-input v-model="formDataJB.model" placeholder="请输入材质"></el-input>
                </el-form-item>
                <el-form-item label="规格:">
                  <el-input v-model="formDataJB.specification" maxlength="20" placeholder="请输入规格"></el-input>
                </el-form-item>
                <el-form-item label="品名:">
                  <el-input v-model="formDataJB.productName" placeholder="请输入品名"></el-input>
                </el-form-item>
                <el-form-item label="重量（吨）:">
                  <el-input maxlength="20" v-model="formDataJB.weight" placeholder="请输入重量"></el-input>
                </el-form-item>
                <el-form-item label="所属客户:">
                  <el-input maxlength="10" v-model="formDataJB.customerName" placeholder="请输入所属客户"></el-input>
                </el-form-item>
                <el-form-item label="进仓单号:">
                  <el-input maxlength="10" v-model="formDataJB.jFInStockNo" placeholder="请输入进仓单号"></el-input>
                </el-form-item>
                <el-form-item label="货物类型:">
                  <el-select v-model="formDataJB.productType" placeholder="请选择货物类型" filterable clearable>
                    <el-option v-for="item in typeData" :label="item.show_name" :key="item.show_name" :value="item.item_no"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="有无货损:">
                  <el-select size="mini" v-model="formDataJB.damageFlg" placeholder="请选择有无货损">
                    <el-option label="有货损" value="1"></el-option>
                    <el-option label="无货损" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="仓库名:">
                    <el-select
                      v-model="cangKuName"
                      size="mini"
                      style="width: 150px"
                      @change="changeXiugaiKW(cangKuName)"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in addKuwei"
                        :label="item.warehouseName"
                        :key="item.warehouseId"
                        :value="item.warehouseId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="区位名:">
                    <el-select
                      v-model="quWeiName"
                      size="mini"
                      style="width: 150px"
                      @change="changeXiugaiQW(quWeiName)"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in addQ"
                        :label="item.locationName"
                        :key="item.locationId"
                        :value="item.locationId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="货位名:">
                    <el-select
                      v-model="huoWeiName"
                      size="mini"
                      style="width: 150px"
                      @change="changeXiugaiHW(huoWeiName)"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in addH"
                        :label="item.binName"
                        :key="item.binId"
                        :value="item.binId"
                      ></el-option>
                    </el-select>
                  </el-form-item> -->
                <el-form-item label="合约号:">
                  <el-input maxlength="20" v-model="formDataJB.agreementNumber" placeholder="请输入合约号"></el-input>
                </el-form-item>
                <el-form-item label="合同号:">
                  <el-input maxlength="20" v-model="formDataJB.contractNumber" placeholder="请输入合同号"></el-input>
                </el-form-item>
                </div>
                <el-form-item style="padding-left: 10px;">
                  <el-button type="primary" size="mini" @click="chaxunJB" btnCode="00ZP00DB001" v-if="btnFlg[0]">查询</el-button>
                  <el-button type="primary" size="mini" @click="chongzhiJB" btnCode="00ZP00D002" v-if="btnFlg[1]">重置</el-button>
                  <el-button type="primary" size="mini" @click="daochuJB" btnCode="00ZP00DB003" v-if="btnFlg[2]">导出</el-button>
                  <el-button type="primary" size="mini" @click="MBdaochuJB" btnCode="00ZP00DB00A" v-if="btnFlg[9]">模板导出</el-button>
                  <el-button type="primary" size="mini" @click="ZXdaochuJB" btnCode="00ZP00DB00C" v-if="btnFlg[11]">忠信库模板</el-button>
                  <span style="margin-left:10px">总吨数：<span style="color:red">{{Number(allWeightJB)}}</span> 吨</span>
                  <span style="margin-left:10px">总件数：<span style="color:red">{{allNumberJB}}</span> 件</span>
                </el-form-item>
              </el-form>
            </div>
            <!--表格-->
            <div class="chuKuZuoyeWarp-body-table" :style="{ height: h }">
              <el-table size="mini" ref="tabref" height="100%" :data="tableDataJB" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row border>
                <el-table-column type="index" align="center" label="序号" width="60" fixed></el-table-column>
                <el-table-column label="货损" align="center" fixed width="100">
                  <template slot-scope="scope">
                    <div>
                      <span v-if="scope.row.damageFlg == 0">无货损</span>
                      <span v-else-if="scope.row.damageFlg == 1">
                        <el-button type="text" size="small" @click="imgShow(scope.row)">查看货损</el-button>
                      </span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" width="250"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓库名" align="center" width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="locationName" label="区位名" width="160" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="binName" label="货位名" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="customerName" label="所属客户" width="220" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center" width="200"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库时间" align="center" width="180" :formatter="dateTimeFormat"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名" align="center" width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="品牌" align="center" width="200"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量（吨）" align="center" width="100"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center" width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号" align="center" width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="vehicleNumber" label="车船号" align="center" width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="oynumber" label="货号" align="center" width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="guaranteedCost" label="保性能" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="trimming" label="切边" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="factoryCategory" label="出厂类别" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="poundWeight" label="磅重" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weighingMethodName" label="计重方式" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" align="center" width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="stockDate" label="库存天数" align="center" width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="ext1" label="到货方式" align="center" width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="jFInstockNo" label="进仓单号" align="center" width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="arrivalNo" label="到货单号" align="center" width="200"></el-table-column>
              </el-table>
            </div>
            <!--分页-->
            <div class="pags" style="text-align: right">
              <el-pagination background @current-change="handleCurrentChangeJB" :current-page="pageInfoJB.pageNo" :page-size="pageInfoJB.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeJB" :total="totalJB"></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="建材库存" name="second" :lazy="true">
          <jc-record v-if="JCVisible && activeName=='second'" :JCVisible.sync="JCVisible"></jc-record>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--点击查看凭证-->
    <div class="addMarkBox">
      <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="60%" center>
        <!-- <div v-if="!imgFlag">
            <div>无货损图片</div>
          </div>-->
        <div class="img_box">
          <div v-for="(item, index) in imgData" :key="index">
            <img :src="item.url" alt />
            <!-- <i v-if="seen" class="el-icon-delete" @click="delImg(item)"></i> -->
            <i class="el-icon-zoom-in" @click="handChange(item.url)"></i>
          </div>
        </div>
        <el-dialog class="oneTwo" :visible.sync="dialogVisible" title="查看凭证" append-to-body width="40%" center :close-on-click-modal="false">
          <div class="imgDialog">
            <img :src="imageD" alt />
          </div>
        </el-dialog>
        <div style="width: 158px; margin: 15px auto"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getWhStockInfoCargoListGT,
  findUserTenantRelList,
  getWhStockInfoCargoList,
  zidianKuwei, // 字典库位
  zidianQuwei, // 字典区位
  zidianHuowei, // 字典货位
  getDictionaryAll, // 字典货位
  exTemplateStockInfoCargoList
} from '@/api/wms-stock'
import { zidian, getCargoDamagePicture } from '@/api/wms-access'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDown.js'
import JcRecord from './JCReport.vue'
export default {
  components: { JcRecord },
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      radio: '1',
      // 卷板
      total: 0,
      pageInfoJB: {
        pageNo: 1,
        pageSize: 20
      },
      formDataJB: {
        productType: '',
        agreementNumber: '',
        customerName: '',
        instockDateStart: '',
        instockDateEnd: '',
        contractNumber: '',
        specification: '',
        productName: '',
        model: '',
        contractNumber: '',
        weight: '',
        damageFlg: '',
        vehicleNumber: '',
        steelMillName: '',
        warehouseId: '',
        locationId: '',
        binId: '',
        customerName: '',
        jFInStockNo: ''
      },
      cangKuName: '', // 仓库名
      quWeiName: '', // 区位名
      huoWeiName: '', // 货位名
      // 字典
      addKuwei: [],
      addQ: [],
      addH: [],
      tableDataJB: [],
      totalJB: 0,
      allWeightJB: 0,
      allNumberJB: 0,
      CKName: [],
      gangJuanNum: '',
      lengthData: [],
      specificationDisabled: true,
      steelMillNameDisabled: true,
      modelDisabled: true,
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: '',
      btnArr: [
        '00ZP00DB001',
        '00ZP00DB002',
        '00ZP00DB003',
        '00ZP00DB004',
        '00ZP00DB005',
        '00ZP00DB006',
        '00ZP00DB007',
        '00ZP00DB008',
        '00ZP00DB009',
        '00ZP00DB00A',
        '00ZP00DB00B',
        '00ZP00DB00C'
      ],
      btnFlg: [],
      h: 500,
      JCVisible: false,
      CKData: [],
      typeId: '', // 冷热卷
      kuweiId: '', // 库位id
      kuweiName: '', // 库位name
      QId: '', // 区位id
      QName: '', // 区位name
      HId: '', // 货位id
      HName: '', // 货位name
      typeName: '',
      typeData: [],
      shareOption: [
        {
          id: '1',
          name: '已共享'
        },
        {
          id: '2',
          name: '未共享'
        }
      ],
      // 锁状态 0未锁 1已锁
      options: [
        {
          id: '0',
          name: '未锁定'
        },
        {
          id: '1',
          name: '已锁定'
        }
      ],
      jincangOption: [
        {
          id: true,
          name: '有进仓单号'
        },
        {
          id: false,
          name: '无进仓单号'
        }
      ],
      addMarkLookBox: false,
      imgData: [],
      dialogVisible: false,
      imageD: ''
    }
  },
  methods: {
    // 查看凭证-放大
    handChange (url) {
      this.imageD = url
      this.dialogVisible = true
    },
    // 图片查看
    imgShow (row) {
      this.addMarkLookBox = true
      getCargoDamagePicture({
        cargoId: row.cargoId // 货物id
      })
        .then((res) => {
          this.imgData = []
          this.imgData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 添加-客户信息
    searchLockState: function (valueS) {
      let choosenItemKehu = this.options.filter(
        (item) => item.name === valueS
      )[0]
      this.loactName = choosenItemKehu.name
      this.loactId = choosenItemKehu.id
    },
    // 获取库位下拉框其他值
    changeXiugaiKW: function (valueS) {
      let choosenKuwei = this.addKuwei.filter(
        (item) => item.warehouseId === valueS
      )[0]
      this.quWeiName = ''
      this.huoWeiName = ''
      this.QId = ''
      this.HId = ''
      this.kuweiId = choosenKuwei.warehouseId
      this.kuweiName = choosenKuwei.warehouseName
      // this.zidianQuweiS()
      zidianQuwei({
        warehouseId: this.kuweiId
      })
        .then((res) => {
          this.addQ = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取区位下拉框其他值
    changeXiugaiQW: function (valueS) {
      let choosenQ = this.addQ.filter((item) => item.locationId === valueS)[0]
      this.QId = choosenQ.locationId
      this.QName = choosenQ.locationName
      this.huoWeiName = ''
      this.HId = ''
      zidianHuowei({
        locationid: this.QId
      })
        .then((res) => {
          this.addH = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取货位下拉框其他值
    changeXiugaiHW: function (valueS) {
      let choosenH = this.addH.filter((item) => item.binId === valueS)[0]
      this.HId = choosenH.binId
      this.HName = choosenH.binName
    },
    // 货物类型卷板
    zidianS () {
      getDictionaryAll({
        groupNo: 'product_type'
      })
        .then(res => {
          this.typeData = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({})
        .then((res) => {
          this.addKuwei = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 字典--区位
    zidianQuweiS () {
      zidianQuwei({
        warehouseId: this.kuweiId
      })
        .then((res) => {
          this.addQ = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 字典--货位
    zidianHuoweiS () {
      // console.log(this.QIds ,this.xuanzhongArr.locationId ,this.QId)
      zidianHuowei({
        locationid: this.QId
      })
        .then((res) => {
          this.addH = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 仓库名称
    findUserTenantRelList () {
      findUserTenantRelList(
        {
          userCode: window.localStorage.getItem('userCode'),
          tenantCode: window.localStorage.getItem('tenantCode')
        }
      )
        .then(res => {
          console.log(res)
          this.CKData = res
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    handleClicktab (tab, event) {
      console.log(tab, event)
      if (tab.name == 'first') {
        this.chongzhiJB()
      } else if (tab.name == 'second') {
        this.JCVisible = true
      }
    },
    // 卷板
    chaxunJB () {
      getWhStockInfoCargoListGT(
        {
          ...this.formDataJB,
          ...this.pageInfoJB,
          organizationIds: this.CKName.join(','),
          cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
          warehouseId: this.kuweiId,
          locationId: this.QId,
          binId: this.HId
        }
      )
        .then(res => {
          console.log(res)
          this.tableDataJB = res.pageInfo.list
          this.totalJB = res.pageInfo.total
          this.allWeightJB = res.allWeight.allWeight
          this.allNumberJB = res.allWeight.allNumber
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chongzhiJB () {
      this.pageInfoJB = {
        pageNo: 1,
        pageSize: 20
      }
      this.formDataJB = {
        productType: '',
        agreementNumber: '',
        customerName: '',
        instockDateStart: '',
        instockDateEnd: '',
        contractNumber: '',
        specification: '',
        productName: '',
        model: '',
        contractNumber: '',
        weight: '',
        damageFlg: '',
        vehicleNumber: '',
        steelMillName: '',
        warehouseId: '',
        locationId: '',
        binId: '',
        customerName: '',
        jFInStockNo: ''
      }
      // this.cangKuName = ''
      // this.quWeiName = ''
      // this.huoWeiName = ''
      this.kuweiId = ''
      this.QId = ''
      this.HId = ''
      this.CKName = []
      this.gangJuanNum = ''
      this.chaxunJB()
    },
    daochuJB () {
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exportStockInfoCargoList',
        {
          ...this.formDataJB,
          organizationIds: this.CKName.join(','),
          cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
          instockStatus: '1',
          warehouseId: this.kuweiId,
          locationId: this.QId,
          binId: this.HId
        },
        '卷板信息表'
      )
    },
    MBdaochuJB () {
      // if (this.CKName.length != 1) {
      //   this.$message.error('请选择一个仓库')
      // } else if (this.formDataJB.customerName == '') {
      //   this.$message.error('请填写所属客户')
      // } else {
      exTemplateStockInfoCargoList(
        {
          ...this.formDataJB,
          organizationIds: this.CKName.join(','),
          cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
          instockStatus: '1',
          warehouseId: this.kuweiId,
          locationId: this.QId,
          binId: this.HId,
          firstRequest: '1'
        }
      ).then(res => {
        console.log(res)
        exportExcel(
          this.global.wmsStockName + '/recordDetails/exTemplateStockInfoCargoList',
          {
            ...this.formDataJB,
            organizationIds: this.CKName.join(','),
            cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
            instockStatus: '1',
            warehouseId: this.kuweiId,
            locationId: this.QId,
            binId: this.HId
          },
          '卷板信息表'
        )
      })
        .catch(error => {
          DonMessage.error(error.message)
        })

      // }
    },
    ZXdaochuJB () {
      let arr = []
      this.CKData.map(item => {
        this.CKName.map(i => {
          if (i == item.relTenantCode) {
            arr.push(item.relTenantName)
          }
        })
      })
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exTemplateZXKStockInfoCargoList',
        {
          ...this.formDataJB,
          organizationIds: this.CKName.join(','),
          cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
          instockStatus: '1',
          warehouseId: this.kuweiId,
          locationId: this.QId,
          binId: this.HId,
          organizationName: arr.join(',')
        },
        '卷板信息表'
      )
    },
    handleCurrentChangeJB (val) {
      this.pageInfoJB.pageNo = val
      this.chaxunJB()
    },
    handleSizeChangeJB (val) {
      this.pageInfoJB.pageSize = val
      this.chaxunJB()
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/kcReport')
    this.chaxunJB()
    this.findUserTenantRelList()
    this.zidianS()
    this.zidianKuweiS()
    this.zidianQuweiS()
    this.zidianHuoweiS()
  },
  mounted () {
    let h = this.$refs.searchBoxJB.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 202 + 'px'
  }
}
</script>

<style lang="less" scoped>
.img_box {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  div {
    widows: 100px;
    height: 110px;
    margin-right: 2px;
    border: 1px dashed #ccc;
    // border-radius: 10px;
    padding: 2px;
    img {
      width: 100px;
      height: 100px;
    }
  }
}
.imgDialog {
  width: 100%;
  // height:60vh;
  // overflow-x: scroll;
  // overflow-y: scroll;
  text-align: center;
  img {
    width: 100%;
    // background-size: 100% 100%;
  }
}
.inpBox1 {
   /deep/.el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
/deep/.el-tabs__header {
  margin: 0;
}
</style>
